import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import clsx from 'clsx';
interface Props {
  markdown: string;
  className?: string;
}
const RichTextComponent: React.FC<Props> = ({ markdown, className }) => {
  return (
    <div className={clsx('prose max-w-full text-neutral-900 dark:text-neutral-50', className)}>
      <ReactMarkdown
        components={{
          li: ({ node, ...props }) => (
            <li className="marker:text-neutral-900 font-inter" {...props} />
          )
        }}
        rehypePlugins={[rehypeRaw]}
        urlTransform={url => {
          return url;
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
};

export default RichTextComponent;
